export interface Holiday {
  id?: string;
  date: Date;
  name: string;
  type: 'fixed' | 'movable';
  isNational: boolean;
}

// Cálculo da Páscoa usando o algoritmo de Meeus/Jones/Butcher
const calculateEaster = (year: number): Date => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  
  return new Date(year, month - 1, day);
};

// Calcular feriados móveis baseados na Páscoa
const calculateMovableHolidays = (year: number): Holiday[] => {
  const easter = calculateEaster(year);
  const easterTime = easter.getTime();
  
  return [
    {
      date: easter,
      name: 'Páscoa',
      type: 'movable',
      isNational: true,
    },
    {
      date: new Date(easterTime - 47 * 24 * 60 * 60 * 1000), // 47 dias antes
      name: 'Carnaval',
      type: 'movable',
      isNational: true,
    },
    {
      date: new Date(easterTime - 2 * 24 * 60 * 60 * 1000), // 2 dias antes
      name: 'Sexta-feira Santa',
      type: 'movable',
      isNational: true,
    },
    {
      date: new Date(easterTime + 60 * 24 * 60 * 60 * 1000), // 60 dias depois
      name: 'Corpus Christi',
      type: 'movable',
      isNational: true,
    },
  ];
};

// Feriados fixos nacionais
const getFixedHolidays = (year: number): Holiday[] => {
  return [
    { date: new Date(year, 0, 1), name: 'Ano Novo', type: 'fixed', isNational: true },
    { date: new Date(year, 3, 21), name: 'Tiradentes', type: 'fixed', isNational: true },
    { date: new Date(year, 4, 1), name: 'Dia do Trabalho', type: 'fixed', isNational: true },
    { date: new Date(year, 8, 7), name: 'Independência do Brasil', type: 'fixed', isNational: true },
    { date: new Date(year, 9, 12), name: 'Nossa Senhora Aparecida', type: 'fixed', isNational: true },
    { date: new Date(year, 10, 2), name: 'Finados', type: 'fixed', isNational: true },
    { date: new Date(year, 10, 15), name: 'Proclamação da República', type: 'fixed', isNational: true },
    { date: new Date(year, 10, 20), name: 'Dia da Consciência Negra', type: 'fixed', isNational: true },
    { date: new Date(year, 11, 8), name: 'Nossa Senhora da Conceição', type: 'fixed', isNational: true },
    { date: new Date(year, 11, 25), name: 'Natal', type: 'fixed', isNational: true },
  ];
};

export const getBrazilianHolidays = (year: number): Holiday[] => {
  return [
    ...getFixedHolidays(year),
    ...calculateMovableHolidays(year),
  ].sort((a, b) => a.date.getTime() - b.date.getTime());
};

export const getHolidaysForMonth = (year: number, month: number): Holiday[] => {
  const allHolidays = getBrazilianHolidays(year);
  return allHolidays.filter(h => h.date.getMonth() === month);
};

export const isHoliday = (date: Date): Holiday | null => {
  const year = date.getFullYear();
  const holidays = getBrazilianHolidays(year);
  
  return holidays.find(h => 
    h.date.getFullYear() === date.getFullYear() &&
    h.date.getMonth() === date.getMonth() &&
    h.date.getDate() === date.getDate()
  ) || null;
};
